 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"advices~instruction":"advices~instruction","advices":"advices","agents~auth~dashboard~employeeDashboard~employeePayments~employeeProfile~employees~instruction~main~~be51a4a0":"agents~auth~dashboard~employeeDashboard~employeePayments~employeeProfile~employees~instruction~main~~be51a4a0","agents~auth~employeePayments~employees~instruction~payments~profile~referral~referrals~roles":"agents~auth~employeePayments~employees~instruction~payments~profile~referral~referrals~roles","instruction":"instruction","agents~employeePayments~employees~payments~referrals":"agents~employeePayments~employees~payments~referrals","agents":"agents","employeePayments":"employeePayments","employees":"employees","main~referral~referrals~roles":"main~referral~referrals~roles","referrals":"referrals","payments":"payments","auth":"auth","referral":"referral","roles":"roles","profile":"profile","dashboard":"dashboard","employeeDashboard":"employeeDashboard","employeeProfile":"employeeProfile","main":"main","employeeAuth":"employeeAuth","error":"error"}[chunkId]||chunkId) + "." + {"advices~instruction":"17ffa0ea","advices":"fb8abc37","agents~auth~dashboard~employeeDashboard~employeePayments~employeeProfile~employees~instruction~main~~be51a4a0":"6e2d5029","agents~auth~employeePayments~employees~instruction~payments~profile~referral~referrals~roles":"5336e044","instruction":"35ff3acf","agents~employeePayments~employees~payments~referrals":"4637ae20","agents":"d9f94a6e","employeePayments":"b1d81db3","employees":"b6ab8662","main~referral~referrals~roles":"1bad1890","referrals":"6332a1c0","payments":"247d3d0b","auth":"030aeb41","referral":"fa42f838","roles":"edc33408","profile":"93035801","dashboard":"8b662077","employeeDashboard":"f2876e43","employeeProfile":"fa4c2599","main":"7ed66456","chunk-1377880d":"a153d50a","chunk-1aed7afe":"a278e0ac","chunk-2d0c7e17":"4650c50f","employeeAuth":"89ecb44d","error":"09811f6d","chunk-743e4b25":"47398025","chunk-74524b79":"2bcfb7ae","chunk-746154ec":"b2d98dcb","chunk-7498e9ec":"ba910fca","chunk-74a82e1a":"a73a41d7","chunk-74b6aca8":"97ec2f39","chunk-76f08193":"a73e0719","chunk-771a7e38":"5cf79c9c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"advices~instruction":1,"advices":1,"agents~auth~employeePayments~employees~instruction~payments~profile~referral~referrals~roles":1,"instruction":1,"agents~employeePayments~employees~payments~referrals":1,"agents":1,"employeePayments":1,"employees":1,"main~referral~referrals~roles":1,"referrals":1,"payments":1,"auth":1,"referral":1,"roles":1,"profile":1,"dashboard":1,"employeeDashboard":1,"employeeProfile":1,"main":1,"chunk-1377880d":1,"chunk-1aed7afe":1,"employeeAuth":1,"error":1,"chunk-743e4b25":1,"chunk-74524b79":1,"chunk-746154ec":1,"chunk-7498e9ec":1,"chunk-74a82e1a":1,"chunk-74b6aca8":1,"chunk-76f08193":1,"chunk-771a7e38":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"advices~instruction":"advices~instruction","advices":"advices","agents~auth~dashboard~employeeDashboard~employeePayments~employeeProfile~employees~instruction~main~~be51a4a0":"agents~auth~dashboard~employeeDashboard~employeePayments~employeeProfile~employees~instruction~main~~be51a4a0","agents~auth~employeePayments~employees~instruction~payments~profile~referral~referrals~roles":"agents~auth~employeePayments~employees~instruction~payments~profile~referral~referrals~roles","instruction":"instruction","agents~employeePayments~employees~payments~referrals":"agents~employeePayments~employees~payments~referrals","agents":"agents","employeePayments":"employeePayments","employees":"employees","main~referral~referrals~roles":"main~referral~referrals~roles","referrals":"referrals","payments":"payments","auth":"auth","referral":"referral","roles":"roles","profile":"profile","dashboard":"dashboard","employeeDashboard":"employeeDashboard","employeeProfile":"employeeProfile","main":"main","employeeAuth":"employeeAuth","error":"error"}[chunkId]||chunkId) + "." + {"advices~instruction":"55b2e515","advices":"05d6ee45","agents~auth~dashboard~employeeDashboard~employeePayments~employeeProfile~employees~instruction~main~~be51a4a0":"31d6cfe0","agents~auth~employeePayments~employees~instruction~payments~profile~referral~referrals~roles":"3e8477cf","instruction":"b95107d7","agents~employeePayments~employees~payments~referrals":"964920dc","agents":"0dbd894e","employeePayments":"9783cf89","employees":"9766d82f","main~referral~referrals~roles":"bb567fad","referrals":"5caf0ae0","payments":"b00be8fa","auth":"732ebc30","referral":"30b924dd","roles":"f1f0dfec","profile":"d6aaa7b1","dashboard":"eaef53cb","employeeDashboard":"2db9b186","employeeProfile":"227a6fc0","main":"dfafb82a","chunk-1377880d":"84c64edb","chunk-1aed7afe":"84291528","chunk-2d0c7e17":"31d6cfe0","employeeAuth":"d8ac19cb","error":"14fa9f17","chunk-743e4b25":"b7e4a7f0","chunk-74524b79":"02574d02","chunk-746154ec":"a30c0971","chunk-7498e9ec":"163ac366","chunk-74a82e1a":"5c34488f","chunk-74b6aca8":"12720cd8","chunk-76f08193":"492d3632","chunk-771a7e38":"4d5bff5a"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
